<p [ngClass]="{'black-text': isTextBlack}">{{text}}</p>